import { Button, Form, Input } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";

const AddDriver = ({ visibleData, onCloseMethod }: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [driverData, setDriverData] = useState(undefined);
  const [driverUrl, setDriverUrl] = useState(undefined);
  const [error, setError] = useState("");

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      mobileNumber: `+88${data?.mobileNumber}`,
      drivingLicense: data?.drivingLicense,
      // city: "0",
      // carRegistrationNumber: "0",
      // manufacturer: "0",
      // model: "0",
      // year: "0",

      // drivingLicense: data.drivingLicense,
      // carRegistrationNumber: data.carRegistrationNumber,
      // manufacturer: data.manufacturer,
      // model: data.model,
      // year: data.year,
    };

    if (driverData) {
      await fetch(`${process.env.REACT_APP_RIDER_API}/driver`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          driverId: driverData.id,
          id: driverData?.id,
          mobileNumber: `+88${data?.mobileNumber}`,
          // year: moment(data?.year).format("YYYY"),
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          if (res.statusCode === 200) {
            responseNotification("Driver Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_RIDER_API}/driver`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(readyData),
        body: JSON.stringify({
          ...readyData,
          mobileNumber: `+88${data?.mobileNumber}`,
          // year: moment(data?.year).format("YYYY"),
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Driver Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setDriverData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (driverData) {
      form.resetFields();
      // setDriverUrl(visibleData?.driverImage);
    }
  }, [driverData]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          // requiredMark="optional"
          initialValues={{
            ...driverData,
            mobileNumber: visibleData?.mobileNumber?.replace("+88", ""),
            drivingLicense: visibleData?.drivingLicense?.drivingLicenseNumber,
            // carRegistrationNumber: visibleData?.car?.carRegistrationNumber,
            // manufacturer: visibleData?.car?.manufacturer,
            // model: visibleData?.car?.model,
            // year: moment(visibleData?.car?.year),
          }}
          // autoComplete="off"
        >
          <Form.Item
            hasFeedback
            label="Deliver Hero Name"
            rules={[
              {
                required: true,
                message: "Name Title is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Mobile Number 01..."
            rules={[
              {
                required: true,
                message: "Mobile Number is required!",
              },
              {
                validator: async (_, names) => {
                  if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                    return Promise.reject(
                      new Error("Enter valid mobile number")
                    );
                  }
                },
              },
            ]}
            name="mobileNumber"
            initialValue={"01"}
          >
            <Input
              id="mobile"
              type="mobile"
              addonBefore={"+88"}
              placeholder="Enter Mobile Number"
              // allowClear
            />
          </Form.Item>

          <Form.Item hasFeedback label="Driving License" name="drivingLicense">
            <Input
              id="drivingLicense"
              type="text"
              placeholder="Enter Driving License Number"
            />
          </Form.Item>

          <Form.Item hasFeedback label="Area" name="city">
            <Input id="city" type="text" placeholder="Enter Area" />
          </Form.Item>

          {/* <Form.Item
            hasFeedback
            label="Bike/Car Registration Number"
            name="carRegistrationNumber"
          >
            <Input
              id="carRegistrationNumber"
              type="text"
              placeholder="Enter Registration Number"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Car/Bike Manufacturer"
            name="manufacturer"
          >
            <Input
              id="manufacturer"
              type="text"
              placeholder="Enter Manufacturer"
            />
          </Form.Item>

          <Form.Item hasFeedback label="Car/Bike Model" name="model">
            <Input id="model" type="text" placeholder="Enter Model" />
          </Form.Item>

          <Form.Item hasFeedback label="Car/Bike Year" name="year">
            <Input id="year" type="text" placeholder="Enter Year" />
          </Form.Item> */}

          {/* <Form.Item
            hasFeedback
            label="Vehicle Type"
            name="type"
          >
            <Select placeholder="Shop Type" style={{ minWidth: 300 }}>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item> */}

          {/* <Form.Item
            hasFeedback
            label="Photo"
            rules={[
              {
                required: true,
                message: "Driver Image is required!",
              },
              {
                validator: async (_, value) => {
                  if (value && !validUrl(value)) {
                    return Promise.reject(new Error("Enter valid url"));
                  }
                },
              },
            ]}
            name="driverImage"
          >
            <Input
              id="driverImage"
              type="text"
              placeholder="Enter Driver Url"
              onChange={(e) => {
                setDriverUrl(e.target.value);
              }}
            />
          </Form.Item>

          {driverUrl && (
            <div className="mt-2" style={{ minWidth: "100%" }}>
              <Image
                src={driverUrl}
                height={150}
                className="img img-thumbnail"
                onLoad={(e) => {
                  const width = (e.target as any).naturalWidth;
                  const height = (e.target as any).naturalHeight;
                  const ratio = width / height;

                  if (ratio.toFixed(1) === "2.5" && height > 400) {
                    setError("");
                  } else {
                    setError(
                      "Image Ratio must be around 2.3 & minimum Height is 400"
                    );
                  }
                }}
              />
              <p className="red-txt mt-1">{error}</p>
            </div>
          )} */}
          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
                setDriverUrl(undefined);
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddDriver;
